import SelectHubspotTargetCompaniesSlide from "./SelectHubspotTargetCompaniesSlide";

export default SelectHubspotTargetCompaniesSlide;
